import {
  FlowDurationUnits,
  FlowFormCompletionWorkflowSignals,
  type FlowWaitForFormCompletionBlockConfig,
  FlowWaitForFormCompletionBlockConfigSchema,
} from 'flow-schema';

import { WaitForFormCompletionFormFields } from './FormFields.tsx';
import { waitForFormCompletionDocumentationMarkdown } from './documentation.ts';
import { type BlockConfigProps } from '../../types';

export const waitForFormCompletionConfig: BlockConfigProps<FlowWaitForFormCompletionBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'waitForForm',
  defaultConfig: {
    signalName: FlowFormCompletionWorkflowSignals.FormSetCompleted,
    timeout: {
      value: 10,
      units: FlowDurationUnits.Minutes,
    },
  },
  configFields: {
    schema: FlowWaitForFormCompletionBlockConfigSchema,
    FormFields: WaitForFormCompletionFormFields,
  },
  documentationMarkdown: waitForFormCompletionDocumentationMarkdown,
};
